import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ProductData } from "../types";

export const createProduct = async (data: ProductData): Promise<ApiResponse> => {
    return await apiClient("/v1/catalogs/product", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: data,
    });
};
